module.exports = __webpack_public_path__ + "static/media/background.7bfd1db8.jpg";